import React from 'react';
import { useSpecialties, specialtyName } from '../lib/useSpecialties';

export function SpecialtyBadges({ ids, testId = 'specialty-badges', className = 'mt-2' }) {
  const data = useSpecialties();
  if (!ids?.length) return null;
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid={testId}>
      {ids.map((id) => (
        <span key={id} className="text-[11px] px-2 py-0.5 rounded-full bg-[#F9F6F0] border border-[#EAE4D9] text-stone-700">
          {specialtyName(data, id)}
        </span>
      ))}
    </div>
  );
}
